import { Component, OnDestroy, OnInit, Input, Inject, LOCALE_ID } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import { DeviceDetectorService } from 'ngx-device-detector';
import { AbstractBiditComponent } from '../shared/controls/abstract.bidit.component';

export interface ContactUsData {
  note: string;
}

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss']
})
export class FooterComponent extends AbstractBiditComponent implements OnInit {

  footerExpand: boolean;

  constructor(@Inject(LOCALE_ID) public locale: string, deviceDetectorService: DeviceDetectorService, private dialog: MatDialog) {
    super(deviceDetectorService);
  }

  @Input()
  public set fullFooter(value: string) {
    if (value) {
      this.footerExpand = true;
    }
  }

  ngOnInit() {
  }

  showContactUs($event) {
    $event.preventDefault();

    const dialogRef = this.dialog.open(ContactUsDialog, {
      width: '500px',
      data: {
        document: document
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      console.log('The dialog was closed');
      if (result) {
        let tmp = 1;
      }
    });
  }
}

@Component({
  selector: 'contact.us.dialog',
  templateUrl: 'contact.us.dialog.html',
})
export class ContactUsDialog {

  constructor(
    public dialogRef: MatDialogRef<ContactUsDialog>,
    @Inject(MAT_DIALOG_DATA) public data: ContactUsData) { }

  onNoClick(): void {
    this.dialogRef.close();
  }
}
